/**
 * frontend/src/components/ArchitectBadge.jsx
 * SoundDAO Sprint 6-Zero Milestone 5 — Architect badge.
 *
 * Awarded for having a Suggestion Box idea actually SHIPPED. Derived
 * server-side from the suggestions table (status = 'shipped'), so there is no
 * badge table and nothing to backfill.
 *
 * Rendered in the same inline slot as ScoutBadge and DayOneBadge.
 * One shipped idea shows 🏗️; two or more show "🏗️ ×N".
 *
 * Props:
 *   count — integer from the leaderboard row's `architect_count`
 */

import React from 'react';

export default function ArchitectBadge({ count }) {
  const n = Number(count) || 0;
  if (n < 1) return null;

  const label = n >= 2 ? `🏗️ ×${n}` : '🏗️';
  const title = n >= 2
    ? `Architect — ${n} shipped ideas`
    : 'Architect — shipped an idea that became part of SoundDAO';

  return (
    <span
      title={title}
      aria-label={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '4px',
        fontSize: '0.85rem',
        cursor: 'default',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
